import {MercantileTemplateData} from "./MercantileTemplateData";
import i18n from "i18next";

export const MercantileImportTemplate = (data: MercantileTemplateData) => {
    return {
        background: [
            {
                image: 'data:image/png;base64,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',
                width: 580,
                alignment: 'center',
                absolutePosition: {x: 0, y: 410}
            }
        ],
        header: [
            {
                image: 'data:image/png;base64,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',
                alignment: 'center',
            },
        ],
        footer: [
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['33%', '33%', '34%'],
                    body: [
                        [
                            {
                                columns: [
                                    {
                                        text: `${i18n.t('Magacioner')}`,
                                        alignment: 'center',
                                        style: 'textRight',
                                        bold: false,
                                        margin: [0, 0, 0, 0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `${i18n.t('Kontrolna kuća')}`,
                                        alignment: 'center',
                                        style: 'textRight',
                                        bold: false,
                                        margin: [0, 0, 0, 0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `${i18n.t('Dobavljač/Vozač')}`,
                                        alignment: 'center',
                                        style: 'textRight',
                                        bold: false,
                                        margin: [0, 0, 0, 0]
                                    },
                                ]
                            },
                        ]
                    ]
                }
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['33%', '33%', '34%'],
                    body: [
                        [
                            {
                                columns: [
                                    {
                                        margin: [0, 10, 0, 0],
                                        "canvas": [{
                                            "lineColor": "gray",
                                            "type": "line",
                                            "x1": 25,
                                            "y1": 0,
                                            "x2": 160,
                                            "y2": 0,
                                            "lineWidth": 1
                                        }]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        margin: [0, 10, 0, 0],
                                        "canvas": [{
                                            "lineColor": "gray",
                                            "type": "line",
                                            "x1": 25,
                                            "y1": 0,
                                            "x2": 160,
                                            "y2": 0,
                                            "lineWidth": 1
                                        }]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        margin: [0, 10, 0, 0],
                                        "canvas": [{
                                            "lineColor": "gray",
                                            "type": "line",
                                            "x1": 25,
                                            "y1": 0,
                                            "x2": 160,
                                            "y2": 0,
                                            "lineWidth": 1
                                        }]
                                    },
                                ]
                            },
                        ]
                    ]
                }
            },
        ],
        content: [
            {
                text: `${i18n.t('Prijemnica br')}: ${(data.finishedId == null || data.finishedId == '') ? '' : data.finishedId}`,
                style: 'title'
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            {
                                text: `${i18n.t('Magacin')}: ${data.warehouse}`,
                                style: 'textLeft'
                            },
                            {
                                text: `${i18n.t('Datum')}: ${data.date} `,
                                style: 'textRight'
                            },
                        ]
                    ]
                }
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            {
                                text: `${i18n.t('Magacinioner')}: ${data.warehouseman}`,
                                style: 'textLeft',
                                margins: [0, 0, 0, 0]
                            },
                            {
                                text: `Vreme: ${data.time}`,
                                style: 'textRight',
                                margin: [0, 0, 0, 5]
                            },
                        ]
                    ]
                }
            },
            {
                "canvas": [{
                    "lineColor": "gray",
                    "type": "line",
                    "x1": 0,
                    "y1": 0,
                    "x2": 515,
                    "y2": 0,
                    "lineWidth": 1
                }]
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            {
                                text: `${i18n.t('Vlasnik/Dobavljac robe')}`,
                                style: 'subtitleLeft',
                                margin: [0, 5, 0, 0]
                            },
                            {
                                text: `${i18n.t('Kupac/ Otkupljivac robe')}:`,
                                style: 'subtitleRight',
                                margin: [0, 5, 0, 0]
                            },
                        ]
                    ]
                }
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            {
                                "canvas": [{
                                    "lineColor": "#00A553",
                                    "type": "line",
                                    "x1": 0,
                                    "y1": 0,
                                    "x2": 160,
                                    "y2": 0,
                                    "lineWidth": 1
                                }]
                            },
                            {
                                "canvas": [{
                                    "lineColor": "#00A553",
                                    "type": "line",
                                    "x1": 100,
                                    "y1": 0,
                                    "x2": 260,
                                    "y2": 0,
                                    "lineWidth": 1,
                                }]
                            },
                        ]
                    ]
                }
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            {
                                columns: [
                                    {
                                        width: '60%',
                                        text: `${i18n.t('Dobavljač')}: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin: [0, 0, 0, 0]
                                    },
                                    {
                                        text: `${data.supplierName}`,
                                        style: 'textLeft',
                                        margin: [0, 0, 0, 0]
                                    }
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `${i18n.t('Kupac')}: `,
                                        style: 'textRight',
                                        bold: true,
                                        margin: [0, 0, 0, 0]
                                    },
                                    {
                                        text: `${data.buyerName}`,
                                        style: 'textRight',
                                        margin: [0, 0, 0, 0]
                                    }
                                ]
                            },
                        ]
                    ]
                }
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            {
                                columns: [
                                    {
                                        text: `${i18n.t('Mesto')}: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin: [0, 0, 0, 0]
                                    },
                                    {
                                        text: `${data.supplierPlace}`,
                                        style: 'textLeft',
                                        margin: [0, 0, 0, 0]
                                    }
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `${i18n.t('Mesto')}: `,
                                        style: 'textRight',
                                        bold: true,
                                        margin: [0, 0, 0, 0]
                                    },
                                    {
                                        text: `${data.buyerPlace}`,
                                        style: 'textRight',
                                        margin: [0, 0, 0, 0]
                                    }
                                ]
                            },
                        ]
                    ]
                }
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            {
                                columns: [
                                    {
                                        width: '25%',
                                        text: `${i18n.t('Adresa')}: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin: [0, 0, 0, 0]
                                    },
                                    {
                                        text: `${data.supplierAddress}`,
                                        style: 'textLeft',
                                        margin: [0, 0, 0, 0]
                                    }
                                ]
                            },
                            {
                            columns: [
                                {
                                    text: `${i18n.t('Adresa')}: `,
                                    style: 'textRight',
                                    bold: true,
                                    margin: [0, 0, 0, 0]
                                },
                                {
                                    text: `${data.buyerAddress}`,
                                    style: 'textRight',
                                    margin: [0, 0, 0, 0]
                                }
                            ]
                        },
                        ]
                    ]
                }
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            {
                                columns: [
                                    {
                                        width: '25%',
                                        text: `${i18n.t('PIB')}: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin: [0, 0, 0, 0]
                                    },
                                    {
                                        text: `${data.supplierPib}`,
                                        style: 'textLeft',
                                        margin: [0, 0, 0, 0]
                                    }
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `${i18n.t('PIB')}: `,
                                        style: 'textRight',
                                        bold: true,
                                        margin: [0, 0, 0, 0]
                                    },
                                    {
                                        text: `${data.buyerPib}`,
                                        style: 'textRight',
                                        margin: [0, 0, 0, 0]
                                    }
                                ]
                            },
                        ]
                    ]
                }
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            {
                                columns: [
                                    {
                                        width: '35%',
                                        text: `${i18n.t('Matični broj')}: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin: [0, 0, 0, 0]
                                    },
                                    {
                                        text: `${data.supplierIdentificationNumber}`,
                                        style: 'textLeft',
                                        margin: [0, 0, 0, 0]
                                    }
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `${i18n.t('Matični broj')}: `,
                                        style: 'textRight',
                                        bold: true,
                                        margin: [0, 0, 0, 0]
                                    },
                                    {
                                        text: `${data.buyerIdentificationNumber}`,
                                        style: 'textRight',
                                        margin: [0, 0, 0, 0]
                                    }
                                ]
                            },
                        ]
                    ]
                }
            },
            {
                "canvas": [{
                    "lineColor": "gray",
                    "type": "line",
                    "x1": 0,
                    "y1": 0,
                    "x2": 515,
                    "y2": 0,
                    "lineWidth": 1
                }]
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            {
                                text: `${i18n.t('Podaci o predatoj robi i vozaču')}:`,
                                style: 'subtitleLeft',
                                margin: [0, 10, 0, 0]
                            },
                            {
                                text: ``,
                                style: 'subtitleRight',
                                margin: [0, 10, 0, 0]
                            },
                        ]
                    ]
                }
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            {
                                "canvas": [{
                                    "lineColor": "#00A553",
                                    "type": "line",
                                    "x1": 0,
                                    "y1": 0,
                                    "x2": 200,
                                    "y2": 0,
                                    "lineWidth": 1
                                }]
                            },
                            {},
                        ]
                    ]
                }
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            {
                                columns: [
                                    {
                                        width: '35%',
                                        text: `${i18n.t('Vrsta robe')}: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin: [0, 0, 0, 0]
                                    },
                                    {
                                        text: `${data.typeOfGoods}`,
                                        style: 'textLeft',
                                        margin: [0, 0, 0, 0]
                                    }
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `${i18n.t('Vozač')}: `,
                                        style: 'textRight',
                                        bold: true,
                                        margin: [0, 0, 0, 0]
                                    },
                                    {
                                        text: `${data.driverName}`,
                                        style: 'textRight',
                                        margin: [0, 0, 0, 0]
                                    }
                                ]
                            },
                        ]
                    ]
                }
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            {
                                columns: [
                                    {
                                        width: '40%',
                                        text: `${i18n.t('Naziv robe')}: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin: [0, 0, 0, 5]
                                    },
                                    {
                                        text: `${data.codeAndNameOfGoods}`,
                                        style: 'textLeft',
                                        margin: [0, 0, 0, 5]
                                    }
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `${i18n.t('Registarske table')}: `,
                                        style: 'textRight',
                                        bold: true,
                                        margin: [0, 0, 0, 0]
                                    },
                                    {
                                        text: `${data.licensePlates}`,
                                        style: 'textRight',
                                        margin: [0, 0, 0, 0]
                                    }
                                ]
                            },
                        ]
                    ]
                }
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['100%'],
                    body: [
                        [
                            {
                                columns: [
                                    {
                                        width: '20%',
                                        text: `${i18n.t('Napomena')}: `,
                                        bold: 'true'
                                    },
                                    {
                                        width: '80%',
                                        text: ` ${data.note}`
                                    }
                                ]
                            }
                        ]
                    ]
                }
            },
            {
                "canvas": [{
                    "lineColor": "gray",
                    "type": "line",
                    "x1": 0,
                    "y1": 0,
                    "x2": 515,
                    "y2": 0,
                    "lineWidth": 1
                }]
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            {
                                text: `${i18n.t('Vaga i laboratorija')}:`,
                                style: 'subtitleLeft',
                                margin: [0, 10, 0, 0]
                            },
                            {
                                text: ``,
                                style: 'subtitleRight',
                                margin: [0, 10, 0, 0]
                            },
                        ]
                    ]
                }
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            {
                                "canvas": [{
                                    "lineColor": "#00A553",
                                    "type": "line",
                                    "x1": 0,
                                    "y1": 0,
                                    "x2": 120,
                                    "y2": 0,
                                    "lineWidth": 1
                                }]
                            },
                            {},
                        ]
                    ]
                }
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            {
                                columns: [
                                    {
                                        width: '35%',
                                        text: `${i18n.t('Bruto')}: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin: [0, 0, 0, 0]
                                    },
                                    {
                                        text: `${data.bruto}`,
                                        style: 'textLeft',
                                        margin: [0, 0, 0, 0]
                                    }
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `${i18n.t('Vlaga')}: `,
                                        style: 'textRight',
                                        bold: true,
                                        margin: [0, 0, 0, 0]
                                    },
                                    {
                                        text: `${data.moisture}`,
                                        style: 'textRight',
                                        margin: [0, 0, 0, 0]
                                    }
                                ]
                            },
                        ]
                    ]
                }
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            {
                                columns: [
                                    {
                                        width: '35%',
                                        text: `${i18n.t('Tara')}: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin: [0, 0, 0, 0]
                                    },
                                    {
                                        text: `${data.tara}`,
                                        style: 'textLeft',
                                        margin: [0, 0, 0, 0]
                                    }
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `${i18n.t('Primese')}: `,
                                        style: 'textRight',
                                        bold: true,
                                        margin: [0, 0, 0, 0]
                                    },
                                    {
                                        text: `${data.impurities}`,
                                        style: 'textRight',
                                        margin: [0, 0, 0, 0]
                                    }
                                ]
                            },
                        ]
                    ]
                }
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['50%', '50%'],
                    body: [
                        [
                            {
                                columns: [
                                    {
                                        width: '35%',
                                        text: `${i18n.t('Neto')}: `,
                                        style: 'textLeft',
                                        bold: true,
                                        margin: [0, 0, 0, 5]
                                    },
                                    {
                                        text: `${data.neto}`,
                                        bold: true,
                                        style: 'textLeft',
                                        margin: [0, 0, 0, 0]
                                    }
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `${('Hibridi/Sorta')}: `,
                                        style: 'textRight',
                                        bold: true,
                                        margin: [0, 0, 0, 0]
                                    },
                                    {
                                        text: `${data.hybridVariety}`,
                                        style: 'textRight',
                                        margin: [0, 0, 0, 0]
                                    }
                                ]
                            },
                        ]
                    ]
                }
            },
            {
                "canvas": [{
                    "lineColor": "gray",
                    "type": "line",
                    "x1": 0,
                    "y1": 0,
                    "x2": 515,
                    "y2": 0,
                    "lineWidth": 1
                }]
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['30%', '35%', '35%'],
                    body: [
                        [
                            {
                                columns: [
                                    {
                                        width: '100%',
                                        text: `${i18n.t('Obračun')}`,
                                        style: 'subtitleLeft',
                                        margin: [0, 0, 0, 0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `${i18n.t('Obračinska količina')}: `,
                                        style: 'textRight',
                                        bold: true,
                                        margin: [0, 10, 0, 0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `${data.accountingQuantity}`,
                                        style: 'textRight',
                                        margin: [0, 10, 0, 0]
                                    }
                                ]
                            },
                        ]
                    ]
                }
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['30%', '35%', '35%'],
                    body: [
                        [
                            {
                                columns: []
                            },
                            {
                                columns: [
                                    {
                                        text: `${i18n.t('Odbitak ili dodatak na vlagu')}: `,
                                        style: 'textRight',
                                        bold: true,
                                        margin: [0, 0, 0, 0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `${data.deductionOrAdditionToMoistureQuantity}`,
                                        style: 'textRight',
                                        margin: [0, 0, 0, 0]
                                    }
                                ]
                            },
                        ]
                    ]
                }
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['30%', '35%', '35%'],
                    body: [
                        [
                            {
                                columns: []
                            },
                            {
                                columns: [
                                    {
                                        text: `${i18n.t('Odbitak ili dodatak na primese')}: `,
                                        style: 'textRight',
                                        bold: true,
                                        margin: [0, 0, 0, 0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `${data.deductionOrAdditionOfImpuritiesQuantity}`,
                                        style: 'textRight',
                                        margin: [0, 0, 0, 0]
                                    }
                                ]
                            },
                        ]
                    ]
                }
            },
            {
                width: '50%',
                layout: 'noBorders',
                table: {
                    widths: ['30%', '35%', '35%'],
                    body: [
                        [
                            {
                                columns: []
                            },
                            {
                                columns: [
                                    {
                                        text: `${i18n.t('SRPS')}: `,
                                        style: 'textRight',
                                        bold: true,
                                        margin: [0, 0, 0, 0]
                                    },
                                ]
                            },
                            {
                                columns: [
                                    {
                                        text: `${data.srps}`,
                                        style: 'textRight',
                                        bold: true,
                                        margin: [0, 0, 0, 0]
                                    },
                                ]
                            },
                        ]
                    ]
                }
            },
            {
                layout: 'noBorders',
                table: {
                    widths:['100%'],
                    body:[
                        [
                            {
                                text: [
                                    {
                                        text: `${i18n.t('Odštampati u 4 primerka')}`,
                                        style: 'textLeft',
                                        bold: true,
                                        margin:[0,0,0,0]
                                    },
                                ]
                            },
                        ]
                    ]
                }
            },
        ],
        styles: {
            title: {
                fontSize: '16',
                alignment: 'center',
                margin: [0, 10, 0, 10],
                bold: true
            },
            subtitle: {
                fontSize: '14',
                alignment: 'center',
                margin: [0, 10, 0, 10],
                bold: true
            },
            subtitleLeft: {
                fontSize: '14',
                alignment: 'left',
                margin: [0, 10, 0, 10],
                bold: true
            },
            subtitleRight: {
                fontSize: '14',
                alignment: 'right',
                margin: [0, 10, 0, 10],
                bold: true
            },
            textLeft: {
                fontSize: '12',
                alignment: 'left',
            },
            textRight: {
                fontSize: '12',
                alignment: 'right',
            }
        }
    }
}
